"use client";

import { GradientWave } from "./gradient-wave";

/* The flagship-card wave: a mesh gradient across the head of a card that
   dissolves into the card's own surface below.

   This exact block — the mask stops, the flat fallback gradient and its colour
   stops, and the per-card seed hash — was written twice independently (the
   homepage's Why Proxidize big cards and the shared Use Cases bento) and had to
   be kept in step by hand. It lives here now so a third caller can't drift.

   The flat wash underneath is not decoration: it covers first paint before the
   WebGL context is ready, and it is the whole backdrop on browsers without
   WebGL. Keep the two sets of stops matched.

   Decorative — always aria-hidden, always behind content. The card that renders
   it needs `relative isolate overflow-hidden` and its own content at z-10. */

/** Stable per-card noise offset, so neighbouring tiles never run the same wave.
 *  Pass something identifying and stable — a title or a slug, not an index. */
export function waveSeed(id: string): number {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) % 997;
  return hash;
}

interface Props {
  seed: number;
}

export function CardWave({ seed }: Props) {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-0 mask-[linear-gradient(to_bottom,#000_0%,#000_36%,transparent_76%)]"
    >
      <div className="light:bg-[linear-gradient(140deg,#f1f5ff,#d8e4ff_45%,#aac4fb)] absolute inset-0 bg-[linear-gradient(140deg,#080d1e,#1a3a6b_45%,#365ecf)]" />
      <GradientWave seed={seed} />
    </div>
  );
}
